import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useLocalStorage } from 'usehooks-ts';

export const useVpnBypass = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [bypassVpn, setBypassVpn] = useLocalStorage<boolean>('bypass-vpn', false);

  useEffect(() => {
    const bypassParam = searchParams.get('bypassVpn') === 'true';
    if (bypassParam) {
      setBypassVpn(true);

      // Clean up URL
      const params = new URLSearchParams(searchParams.toString());
      params.delete('bypassVpn');
      const newUrl = params.toString() ? `?${params.toString()}` : window.location.pathname;
      navigate(newUrl, { replace: true });
    }
  }, [searchParams, navigate, setBypassVpn]);

  return {
    bypassVpn,
    setBypassVpn,
  };
};
